<template>
  <div>
    <b-row class="mb-2">
      <b-col cols="12">
        <div class="d-flex justify-content-between align-items-center">
          <b-form-checkbox
            :checked="!filtersHidden"
            @change="() => (filtersHidden = !filtersHidden)"
            class="mb-0"
          >
            <b>show filters</b>
          </b-form-checkbox>

          <div class="d-flex align-items-center" v-if="!hideShowDeleted">
            <b-form-checkbox
              v-model="showDeletedRevenues"
              switch
              @change="getAllExpense"
              class="custom-blue-switch mr-1"
            />
            <span style="font-size: 0.8rem;">Show Deleted Revenues</span>
          </div>
        </div>
      </b-col>
    </b-row>
    <!-- <b-row align-h="end" class="mb-1 pr-1">
      <b-button
        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
        variant="outline-primary"
        size="sm"
        class=""
        @click="() => (this.filtersHidden = !this.filtersHidden)"
      >
        {{ filtersHidden == true ? "Show Filters" : "Hide Filters" }}
      </b-button>
    </b-row> -->
    <b-card v-if="filtersHidden == false">
      <!-- <b-card-header class="pb-50">
      <h5>Filters</h5>
    </b-card-header> -->

      <b-row class="d-flex align-items-center"  >
        <b-col cols="12" md="3" class="mb-md-0 mt-1 " v-if="!hideMovie">
          <b-form-group >
            <master-select
              id="movie"
              class="w-100 inputBorder"
              placeholder="Select Movie"
              v-model="form.movie"
              label="name"
              :reduce="(option) => option.id"
              :options="$store.state.master.movies"
              :loading="this.$store.state.master.loading.movies"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              @search="onSearch"
            />
          </b-form-group>
        </b-col>
        <b-col cols="12" md="3" class="mb-md-0 mt-1" v-if="!hideVendor">
          <b-form-group>
            <master-select
              id="vendor"
              class="w-100 inputBorder"
              placeholder="Select Licensee/Licensor/Contact"
              v-model="form.vendor"
              label="company"
              :options="$store.state.master.vendors"
              :loading="this.$store.state.master.loading.vendors"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            />
          </b-form-group>
        </b-col>
        <!-- <b-col cols="12" md="3" class="mb-md-0 mb-2" v-if="!hideTerritory">
          <b-form-group>
            <master-select
              id="territory"
              class="w-100"
              placeholder="Select Territory"
              v-model="form.territory"
              label="lbl_name"
              :options="$store.state.master.territory"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            />
          </b-form-group>
        </b-col> -->
        <b-col cols="12" md="3" class="mb-md-0 mt-1" v-if="!hideRight">
          <b-form-group>
            <master-select
              id="right"
              class="w-100 inputBorder"
              placeholder="Select Right"
              v-model="form.right"
              label="lbl_name"
              :options="$store.state.master.rights"
              :loading="this.$store.state.master.loading.rights"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            />
          </b-form-group>
        </b-col>
        <b-col cols="12" md="3" class="mb-md-0 mt-1" v-if="!hideLanguage">
          <b-form-group>
            <master-select
              id="language"
              class="w-100 inputBorder"
              placeholder="Select Language"
              v-model="form.language"
              label="lbl_name"
              :options="$store.state.master.language"
              :loading="this.$store.state.master.loading.language"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            />
          </b-form-group>
        </b-col>
        <b-col cols="12" md="3" class="mb-md-0 mt-1" v-if="!hideStatus">
          <b-form-group>
            <v-select
              id="status"
              class="w-100 inputBorder"
              placeholder="Select Status"
              v-model="form.status"
              :options="statusOptions"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            />
          </b-form-group>
        </b-col>
        <b-col cols="12" md="2" class="mb-md-0 mt-1" v-if="!hideDateRange">
          <b-form-group>
            <flat-pickr
              id="date_range"
              v-model="form.date_range"
              :config="{ ...$flatPickrConfig, mode: 'range' }"
              class="form-control btnBorder"
              placeholder="Select Date Range"
            />
          </b-form-group>
        </b-col>
        <b-col md="4" class="">
          <div class="d-flex align-items-center justify-content-start flex-wrap gap-1">
           
            <b-button size="md" v-ripple.400="'rgba(255, 255, 255, 0.15)'" @click.prevent="submitForm" class="buttonColor btnBorder">
              Search
            </b-button>

            <b-button size="md" v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="outline-secondary" class="ml-1 btnBorder" @click="resetForm">
              Reset
            </b-button>

            <b-button v-if="!hideExportButton" size="md" type="submit" v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="outline-success" class="ml-1 btnBorder" @click="downloadCSV">
              Export CSV
            </b-button>

            <!-- Show Deleted Switch -->
            <!-- <div class="d-flex align-items-center ml-2" v-if="$route.path !== '/home'">
              <b-form-checkbox
                v-model="showDeletedRevenues"
                switch
                @change="getAllExpense"
                class="custom-blue-switch mr-1"
              />
              <span style="font-size: 0.8rem;">Show Deleted Revenues</span>
            </div> -->
          </div>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import {
  BForm,
  BFormGroup,
  BCard,
  BCardHeader,
  BCardBody,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BFormCheckbox,
} from "bootstrap-vue";
import vSelect from "vue-select";
import Ripple from "vue-ripple-directive";
import flatPickr from "vue-flatpickr-component";

import { labels } from "@/utils/constants";

export default {
  components: {
    BForm,
    BFormGroup,
    BCard,
    BCardHeader,
    BCardBody,
    BRow,
    BCol,
    BFormInput,
    BButton,
    vSelect,
    flatPickr,
    BFormCheckbox,
  },
  props: {
    hideMovie: Boolean,
    hideVendor: Boolean,
    hideTerritory: Boolean,
    hideRight: Boolean,
    hideLanguage: Boolean,
    hideStatus: Boolean,
    hideDateRange: Boolean,
    hideExportButton: Boolean,
    hideShowDeleted: Boolean,
    showFilters: { type: Boolean, default: true },
    initialFilters: { type: Object, default: null },
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      showDeletedRevenues: false,
      filtersHidden: true,
      statusOptions: [
        { value: "0", label: "Active" },
        { value: "1", label: "Inactive" },
        { value: "2", label: "All" },
      ],

      form: {
        movie: null,
        vendor: null,
        territory: null,
        right: null,
        language: null,
        status: null,
        date_range: null,
      },
      searchTerm: "",
    };
  },

  methods: {
    getAllExpense() {
      this.$emit("getAllExpense", this.showDeletedRevenues);
    },
    submitForm() {
      //console.log(this.form, "form");

      this.$emit("submitFilter", this.form);
    },
    downloadCSV() {
      this.$emit("downloadCSV");
    },
    resetForm() {
      this.$emit("resetFilter");
      this.form = {
        movie: null,
        vendor: null,
        territory: null,
        right: null,
        language: null,
        status: null,
        date_range: null,
      };
    },
    onSearch(searchTerm) {
      return;
      this.searchTerm = searchTerm;
      this.$store.dispatch("master/setMoviesMaster", { search: searchTerm });
    },
  },

  beforeMount() {
    this.$store.dispatch("master/setVendorsMaster");
    this.$store.dispatch("master/setMoviesMaster");
    if (!this.$store.state.master.territory.length) {
      this.$store.dispatch("master/setLabelMaster", { key: labels.territory });
    }
    if (!this.$store.state.master.rights.length) {
      this.$store.dispatch("master/setLabelMaster", { key: labels.rights });
    }
    if (!this.$store.state.master.language.length) {
      this.$store.dispatch("master/setLabelMaster", { key: labels.language });
    }

    this.filtersHidden = this.showFilters == true ? false : true;

    if (this.initialFilters) {
      this.form = { ...this.form, ...this.initialFilters };
    }
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-flatpicker.scss";

.btnBorder {
  border-radius: 10px !important;
}

.inputBorder .vs__dropdown-toggle {
  border-radius: 10px !important;
}

</style>
